import { makeStyles } from '@mui/styles';

const getCellSize = (percentage: number) => {
  return `calc(100% * ${percentage / 100})`;
};

export const useTableRowStyles = makeStyles((theme) => ({
  rowContent: {
    display: 'flex',
    flex: '1 1 0',
    minWidth: 0,
  },

  cell: {
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '16px 12px',
    minWidth: 0,
  },

  headerTextWrap: {
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    lineHeight: 1.2,
  },

  idCell: {
    minWidth: '0',
    width: getCellSize(5),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(8),
    },
  },

  providerIdCell: {
    minWidth: '64px',
    width: getCellSize(7),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(9),
    },
  },

  riskCell: {
    minWidth: '80px',
    paddingLeft: '24px',
    width: getCellSize(8),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(10),
    },
  },

  productTypeCell: {
    minWidth: '64px',
    width: getCellSize(5),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(7),
    },
  },

  defaultRateCell: {
    minWidth: '54px',
    width: getCellSize(5),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(6),
    },
  },

  nominalInterestCell: {
    minWidth: '62px',
    width: getCellSize(5),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(6),
    },
  },

  statusCell: {
    minWidth: '90px',
    width: getCellSize(8),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(11),
    },
  },

  timeLeftCell: {
    minWidth: '72px',
    width: getCellSize(6),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(7),
    },
  },

  amountCell: {
    minWidth: '96px',
    width: getCellSize(8),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(10),
    },
  },

  dateCell: {
    minWidth: '84px',
    width: getCellSize(8),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(9),
    },
  },

  irrCell: {
    minWidth: '64px',
    width: getCellSize(10),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(11),
    },
  },

  priceCell: {
    paddingLeft: '16px',
    minWidth: '96px',
    width: getCellSize(9),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(13),
    },
  },

  publicationDateCell: {
    minWidth: '80px',
    width: getCellSize(7),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(10),
    },
  },

  inputCell: {
    display: 'flex',
    maxWidth: 'calc(107px + 32px)',
    minWidth: 'calc(107px + 32px)',
    width: 'calc(107px + 32px)',
    minHeight: 'calc(34px + 36px)',
    flexShrink: 0,
    paddingLeft: '16px',
    paddingRight: '16px',
  },
}));
